import {
    Component,
    ElementRef,
    Input,
    OnChanges,
    ViewChild,
CUSTOM_ELEMENTS_SCHEMA
} from '@angular/core';
import { DocumentService } from '@app/core/services/document/document.service';
import { ToolService } from '@app/core/services/tool/tool.service';
import { environment } from '@environment/environment';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@Component({
    selector: 'app-resources',
    templateUrl: './resources.component.html',
    styleUrls: ['./resources.component.scss'],
    standalone: true,
    imports: [CommonModule, FormsModule, ReactiveFormsModule, IonicModule],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]})
export class ResourcesComponent implements OnChanges {
    @Input() myDocuments: any;
    @ViewChild('downloadZipLink', { static: true })
    private downloadZipLink: ElementRef;
    textcontent: any;
    constructor(
        private documentService: DocumentService,
        private toolService: ToolService
    ) {}

    ngOnChanges() {
        this.toolService.content.subscribe(
            (textcontent: any) => (this.textcontent = textcontent)
        );
    }

    downloadImmunizationForm = () => {
        this.documentService
            .downloadImmunizationForm()
            .subscribe((res: any) => {
                const base64str = res.Body.data;
                const binary = atob(base64str.replace(/\s/g, ''));
                const len = binary.length;
                const buffer = new ArrayBuffer(len);
                const view = new Uint8Array(buffer);
                for (let i = 0; i < len; i++) {
                    view[i] = binary.charCodeAt(i);
                }
                const blob = new Blob([view], { type: 'application/pdf' });
                const url = URL.createObjectURL(blob);
                const link = this.downloadZipLink.nativeElement;
                link.href = url;
                link.download =
                    'AMOpportunities_Certificate_of_Immunization.pdf';
                link.click();
                window.URL.revokeObjectURL(url);
            });
    };

    paidDocs = (document: string) => {
        if (document === 'visaGuide') {
            const link = this.downloadZipLink.nativeElement;
            link.href = this.textcontent.document.components.resources.downloadLinkspaidUserDocs.successB1Visa;
            link.target = '_blank';
            link.click();
            return;
        }
        if (document === 'VisaInterview') {
            const link = this.downloadZipLink.nativeElement;
            link.href = this.textcontent.document.components.resources.downloadLinks.paidUserDocs.successVisaInterview;
            link.target = '_blank';
            link.click();
            return;
        }
        if (document === 'visaPacket') {
            const link = this.downloadZipLink.nativeElement;
            link.href = this.textcontent.document.components.resources.downloadLinks.paidUserDocs.successVisa;
            link.target = '_blank';
            link.click();
            return;
        }
        if (document === 'handsonObservership') {
            const link = this.downloadZipLink.nativeElement;
            link.href = this.textcontent.document.components.resources.downloadLinks.paidUserDocs.handsOnOvserverships;
            link.target = '_blank';
            link.click();
            return;
        }
        if (document === 'immunizationGuide') {
            const link = this.downloadZipLink.nativeElement;
            link.href = this.textcontent.document.components.resources.downloadLinks.paidUserDocs.immunizationGuide;
            link.target = '_blank';
            link.click();
            return;
        }
        if (document === 'LOR') {
            const link = this.downloadZipLink.nativeElement;
            link.href = this.textcontent.document.components.resources.downloadLinks.paidUserDocs.LOR;
            link.target = '_blank';
            link.click();
            return;
        }
        if (document === 'successGuide') {
            const link = this.downloadZipLink.nativeElement;
            link.href = this.textcontent.document.components.resources.downloadLinks.paidUserDocs.successGuide;
            link.target = '_blank';
            link.click();
            return;
        }
        if (document === 'deansLetter') {
            const link = this.downloadZipLink.nativeElement;
            link.href = this.textcontent.document.components.resources.downloadLinks.paidUserDocs.sampleDeansLetter;
            link.target = '_blank';
            link.click();
            return;
        }
    };

    downloadDocs = (document: string) => {
        if (document === 'cv') {
            const link = this.downloadZipLink.nativeElement;
            link.href = environment.DOCUMENT_SAMPLE_CV;
            link.target = '_blank';
            link.click();
            return;
        }
        if (document === 'guide') {
            const link = this.downloadZipLink.nativeElement;
            link.href = environment.SAMPLE_DEPARTURE_GUIDE;
            link.target = '_blank';
            link.click();
            return;
        }
        if (document === 'advisor') {
            const link = this.downloadZipLink.nativeElement;
            link.href = this.textcontent.document.components.resources.downloadLinks.generalUserDocs.advisor;
            link.target = '_blank';
            link.click();
            return;
        }
        if (document === 'budgetEarly') {
            const link = this.downloadZipLink.nativeElement;
            link.href = this.textcontent.document.components.resources.downloadLinks.generalUserDocs.budgetEarly;
            link.target = '_blank';
            link.click();
            return;
        }
        if (document === 'budgetFinal') {
            const link = this.downloadZipLink.nativeElement;
            link.href = this.textcontent.document.components.resources.downloadLinks.generalUserDocs.budgetFinal;
            link.target = '_blank';
            link.click();
            return;
        }
        if (document === 'budgetGraduates') {
            const link = this.downloadZipLink.nativeElement;
            link.href = this.textcontent.document.components.resources.downloadLinks.generalUserDocs.budgetGraduates;
            link.target = '_blank';
            link.click();
            return;
        }
        if (document === 'cvGuide') {
            const link = this.downloadZipLink.nativeElement;
            link.href = this.textcontent.document.components.resources.downloadLinks.generalUserDocs.cvGuide;
            link.target = '_blank';
            link.click();
            return;
        }
        if (document === 'family') {
            const link = this.downloadZipLink.nativeElement;
            link.href = this.textcontent.document.components.resources.downloadLinks.generalUserDocs.family;
            link.target = '_blank';
            link.click();
            return;
        }
        if (document === 'legitimacy') {
            const link = this.downloadZipLink.nativeElement;
            link.href = this.textcontent.document.components.resources.downloadLinks.generalUserDocs.legitimacy;
            link.target = '_blank';
            link.click();
            return;
        }
        if (document === 'rotations') {
            const link = this.downloadZipLink.nativeElement;
            link.href = this.textcontent.document.components.resources.downloadLinks.generalUserDocs.rotations;
            link.target = '_blank';
            link.click();
            return;
        }
        if (document === 'fathers') {
            const link = this.downloadZipLink.nativeElement;
            link.href = this.textcontent.document.components.resources.downloadLinks.generalUserDocs.fathers;
            link.target = '_blank';
            link.click();
            return;
        }
        if (document === 'mothers') {
            const link = this.downloadZipLink.nativeElement;
            link.href = this.textcontent.document.components.resources.downloadLinks.generalUserDocs.mothers;
            link.target = '_blank';
            link.click();
            return;
        }
        if (document === 'university') {
            const link = this.downloadZipLink.nativeElement;
            link.href = this.textcontent.document.components.resources.downloadLinks.generalUserDocs.university;
            link.target = '_blank';
            link.click();
            return;
        }
    };

    youtubeLink = (name: string): void => {
        if (name === 'LOR') {
            window.open(this.textcontent.basic.youtube.LOR, '_blank');
        } else if (name === 'housing') {
            window.open(this.textcontent.basic.youtube.housing, '_blank');
        } else if (name === 'handson') {
            window.open(this.textcontent.basic.youtube.handson, '_blank');
        } else if (name === 'immunizations') {
            window.open(this.textcontent.basic.youtube.immunizations, '_blank');
        } else if (name === 'b1Visa') {
            window.open(this.textcontent.basic.youtube.b1Visa, '_blank');
        }
    };
}
